


import React, { PureComponent } from 'react';
import { View, StyleSheet, Image, Text, Dimensions, Platform } from 'react-native';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { Heading, HeadingTypes } from '../../components';
import { moderateScale } from 'react-native-size-matters';
import OrderMealImage from '../../assets/images/rounded-edges-meal.png'
import { scaleText, defaultScale } from '../../utils/scaling';

const width = Dimensions.get('window').width;
const height = Dimensions.get("window").height;
const isWeb = Platform.OS === 'web';
const isLargeScreen = height > 850 && Platform.OS !== 'web';

class MealDeliveryDescriptionWithImage extends PureComponent {
    renderImage = () => {
        let imageWidth = isWeb ? moderateScale(250, 1.2) : isLargeScreen ? moderateScale(150, 2) : moderateScale(250, 1.2);
        let imageHeight = isWeb ? moderateScale(150, 1.2) : isLargeScreen ? moderateScale(100, 2) : moderateScale(150, 1.2);
        return (<Image
            resizeMode={"contain"}
            style={{
                width: imageWidth,
                height: imageHeight,
                margin: 2.5,
                marginHorizontal: 10,
            }}
            source={require('../../assets/images/rounded-edges-meal.png')}
        />);
    }
    render() {
        const {t}= this.props
        return (
            <View style={{ backgroundColor: Theme.WHITE, padding: 10 }}>
                <Heading
                    title={"Ready-made meals, delivered to your door."}
                    style={styles.heading}
                    headerType={HeadingTypes.HEADING_ONE}
                />
                <View style={styles.imageContainer}>
                    {this.renderImage()}
                </View>
                <Text style={styles.description}>{t("orderMeals")}</Text>
            </View >
        )
    }
}


const styles = StyleSheet.create({
    formLabel: {
        fontSize: 15,
        fontFamily: Theme.Custom600,
        paddingVertical: 5,
        color: Theme.GREY_MEDIUM,
    },
    heading: {
        ...Theme.textStyle.bodyCopyBold,
        fontSize: scaleText(21),
        color: Theme.DARK_CHARCOAL,
        textAlign: 'left',
    },
    imageContainer: {
        paddingVertical: 15,
        alignSelf: 'center'
    },
    description: {
        ...Theme.textStyle.small,
        fontSize: scaleText(13),
        color: Theme.DARK_CHARCOAL,
        lineHeight: 18,
        paddingVertical: defaultScale(5),
        paddingBottom: defaultScale(10)
    }
});
export default translate(['nutrition'], { wait: true })(MealDeliveryDescriptionWithImage);
